import type { ReactNode } from 'react';

export const symbol_watch_button: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M228-160q-7 24-16 47.5T191-66q-5 11-16.5 13.5T152-56q-11-6-13.5-17.5T141-96q45-90 52-186.5t7-197.5q0-100-7-196.5T141-862q-5-11-2-23t14-18q11-6 22.5-3t16.5 14q11 23 20 46t16 46h85q64 0 109 47t45 114v317q0 68-45 115t-109 47h-85Zm465-290 58 62q8 9 8 21t-9 21q-9 9-21.5 9t-21.5-9L598-459q-8-9-8-21t8-21l109-112q8-9 21-9t22 9q8 8 8.5 20t-7.5 21l-58 62h159q13 0 21.5 8.5T882-480q0 13-8.5 21.5T852-450H693ZM243-221h70q39 0 66.5-29.5T407-322v-317q0-42-27.5-71.5T313-740h-70q12 63 14.5 127.5T260-480q0 68-3 132.5T243-221Zm17-259Z"
		/>
	</svg>
);
